module.exports = __webpack_public_path__ + "img/link_icon_2.8e2639e.png";